<template>
  <div class="detail-dialog">
    <el-dialog :title="'家校沟通' + detailType" :close-on-click-modal="false" :visible.sync="communicationDetailDialogShow" width="1000px"
      :before-close="dialogClose" @open="dialogOpen">
      <!-- 学年学期 -->
      <el-form ref="ruleForm" label-width="100px" class="ruleForm" label-position="top" :inline="true">
        <el-form-item label="选择学年:" label-width="100px" prop="schoolYear">
          <el-input v-model="formData.schoolYear" disabled placeholder="请输入学年"></el-input>
        </el-form-item>
        <el-form-item label="选择学期:" label-width="100px" prop="semester">
          <el-select v-model="formData.semester" disabled placeholder="请选择学期" style="width: 235px">
            <el-option v-for="item in semesterOptions" :key="item.dictValue" :label="item.dictLabel"
              :value="item.dictValue">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="visit-form-container">
        <el-form ref="formRef" :model="formData" :rules="rules">
          <!-- 第一行：沟通方式、时间、地点、被访学生 -->
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="沟通方式" prop="commMethod">
                <el-radio-group v-model="formData.commMethod">
                  <el-radio :label="item.dictLabel" v-for="(item, index) in communicationMethodOptions" :key="index">{{
                    item.dictLabel }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="时间" prop="interviewTime">
                <!-- <el-input v-model="formData.interviewTime" placeholder="请输入时间" /> -->
                <el-date-picker ref="datePicker" v-model="formData.interviewTime" type="date" value-format="yyyy-MM-dd"
                  placeholder="选择时间">
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="地点" prop="interviewAddress">
                <el-input v-model="formData.interviewAddress" placeholder="请输入地点" />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="被访学生" prop="studentName">
                <el-input v-model="formData.studentName" placeholder="请输入被访学生" />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第二行：被访家长、其他人员、谈话主题 -->
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="被访家长" prop="interviewee">
                <el-input v-model="formData.interviewee" placeholder="请输入被访家长" />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="其他人员" prop="otherPersonnel">
                <el-input v-model="formData.otherPersonnel" placeholder="请输入其他人员" />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="谈话主题" prop="talkTopic">
                <el-input v-model="formData.talkTopic" placeholder="请输入谈话主题" />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 学生最近情况 -->
          <el-form-item label="一、学生最近情况" prop="studentRecentStatus">
            <el-input type="textarea" v-model="formData.studentRecentStatus" :rows="4" maxlength="1000" show-word-limit
              placeholder="请输入学生最近情况..." />
          </el-form-item>

          <!-- 家长家庭教育方式 -->
          <el-form-item label="二、家长教育方式或观念、孩子在家表现" prop="interviewContent">
            <el-input type="textarea" v-model="formData.interviewContent" :rows="4" maxlength="1000" show-word-limit
              placeholder="请输入家长教育方式和孩子在家表现..." />
          </el-form-item>

          <!-- 家庭教育指导建议 -->
          <el-form-item label="三、家庭教育指导建议" prop="guideSuggestions">
            <el-input type="textarea" v-model="formData.guideSuggestions" :rows="4" maxlength="1000" show-word-limit
              placeholder="请输入家庭教育指导建议..." />
          </el-form-item>
        </el-form>
      </div>
      <div class="btn-list" v-if="detailType == '修改'">
        <el-button type="primary" @click="submit">确认</el-button>
      </div>
      <!-- <el-form ref="ruleForm" label-width="100px" class="ruleForm" label-position="top" :inline="true">
        <el-form-item label="沟通时间:" label-width="100px" prop="communicationTime">
          <el-input v-model="detailData.interviewTime" disabled placeholder="请输入时间"></el-input>
        </el-form-item>
        <el-form-item label="沟通地点" prop="communicationPlace" class="title">
          <el-input v-model="detailData.interviewAddress" disabled placeholder="请输入地点"></el-input>
        </el-form-item>
      </el-form>
      <el-form ref="ruleForm" label-width="100px" class="ruleForm" label-position="top">
        <el-form-item label="沟通内容" prop="communicationContent">
          <el-input type="textarea" disabled :autosize="{ minRows: 6, maxRows: 8 }"
            v-model="detailData.interviewContent" :maxlength="maxlength" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="沟通结果" prop="communicationResult">
          <el-input type="textarea" disabled :autosize="{ minRows: 6, maxRows: 8 }" v-model="detailData.interviewResult"
            :maxlength="maxlength" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div class="upload">
        <el-image v-for="item in srcList" :key="item" style="width: 100px; height: 100px; margin-right: 10px;"
          :src="item" :preview-src-list="srcList">
        </el-image>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import { baseURL } from "@/api/request"; // 服务器地址
import axios from "axios";
export default {
  props: [
    'communicationDetailDialogShow',
    'detailData',
    'semesterOptions',
    'communicationMethodOptions',
    'studentId',
    'studentName',
    'detailType'
  ],
  data() {
    // 公共必填规则
    const requiredRule = (message = '该字段不能为空') => [
      { required: true, message, trigger: 'blur' }
    ];
    const noRequiredRule = (message = '该字段不能为空') => [
      { required: false, message, trigger: 'blur' }
    ];
    const requiredRuleChange = (message = '该选项不能为空') => [
      { required: true, message, trigger: 'change' }
    ];
    return {
      maxlength: 1000,
      url: '',
      srcList: [],
      // 表单数据模型
      formData: {
        commMethod: '家访', // 默认值
        interviewTime: '',
        interviewAddress: '',
        studentName: '',
        interviewee: '',
        otherPersonnel: '',
        talkTopic: '',
        studentRecentStatus: '',
        interviewContent: '',
        guideSuggestions: '',
        schoolYear: '',
        semester: '',
      },
      // 所有字段都为必填项
      rules: {
        commMethod: requiredRuleChange('请选择沟通方式'),
        interviewTime: requiredRule('请输入时间'),
        interviewAddress: requiredRule('请输入地点'),
        studentName: requiredRule('请输入被访学生姓名'),
        interviewee: requiredRule('请输入被访家长姓名'),
        otherPersonnel: noRequiredRule('请输入其他人员'),
        talkTopic: requiredRule('请输入谈话主题'),
        studentRecentStatus: requiredRule('请输入学生最近情况'),
        interviewContent: requiredRule('请输入家长教育方式及表现'),
        guideSuggestions: requiredRule('请输入家庭教育指导建议'),
        schoolYear: requiredRuleChange('请选择学年'),
        semester: requiredRuleChange('请选择学期')
      },
      action: "", // 文件上传路径
    };
  },
  mounted() {
    // this.srcList = this.detailData.interviewPictureUrl.split(',');
    // this.url = this.srcList[0];
    // console.log(this.communicationMethodOptions, this.detailData);
    // this.formData.commMethod = this.detailData.commMethod;
    this.formData = JSON.parse(JSON.stringify(this.detailData));
    const foundItem = this.communicationMethodOptions.find(
      item => item.dictValue == this.detailData.commMethod
    );
    this.formData.commMethod = foundItem ? foundItem.dictLabel : '';

    this.action = `${baseURL}${this.$url.editSchoolHomeInterview}`;
  },
  methods: {
    // 开启弹窗
    dialogOpen() {
      // this.srcList = this.detailData.interviewPictureUrl.split(',');
      // this.url = this.srcList[0];
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:communicationDetailDialogShow", false);

      this.formData = {
        commMethod: '家访', // 默认值
        interviewTime: '',
        interviewAddress: '',
        studentName: '',
        interviewee: '',
        otherPersonnel: '',
        talkTopic: '',
        studentRecentStatus: '',
        interviewContent: '',
        guideSuggestions: '',
        schoolYear: '',
        semester: '',
      };
    },
    submit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          let { commMethod, ...restFormData } = this.formData;

          let data = {
            ...restFormData,
            commMethod: this.communicationMethodOptions.find(
              item => item.dictLabel === this.formData.commMethod
            ).dictValue,
            schoolId: this.school.id,
            schoolName: this.school.schoolName,
            studentId: this.studentId,
            studentName: this.studentName,
            teacherId: this.user.id,
            teacherName: this.user.teacherName,
          };

          let config = {
            headers: {
              bbfAdminTeacherToken: window.localStorage.getItem("bbfAdminTeacherToken"),
              "Content-Type": "multipart/form-data",
            },
          };

          // 转换为 FormData
          const formActionData = new FormData();
          Object.entries(data).forEach(([key, value]) => {
            formActionData.append(key, value);
          });

          // 调用接口
          axios
            .put(this.action, formActionData, config)
            .then((res) => {
              // res.data 服务器返回的数据
              console.log(res);
              if (res.data.code == 200) {
                // 上传成功，刷新列表，关闭dialog
                this.$message.success(res.data.msg);
                this.$emit("refresh");
                this.dialogClose();
                return;
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch((err) => {
              console.log(err);
            });

        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./communicationDetailDialog.scss";
</style>